import { Access, List } from "../Components/index.js";

export default [
    {
        path: "/admin/setting/appointment",
        component: List,
        name: "setting.appointment",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/user/access",
        component: Access,
        name: "admin.user.setting.access",
        meta: {
            requiresAuth: true,
        },
    },
];
